var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDictionaries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .statd_s0 { fill: #54affc } \n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-workspace-stat-dictionaries"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-workspace-stat-dictionaries-path",
    fillRule: "evenodd",
    className: "statd_s0",
    d: "m16 2v16c0 1.1-0.9 2-2 2h-12c-1.1 0-2-0.9-2-2v-16c0-1.1 0.9-2 2-2h12c1.1 0 2 0.9 2 2zm-7.4 10.8l-2.2-5.7h-0.9l-2.1 5.7h1l0.5-1.3h2.2l0.4 1.3zm4.1-0.1q-0.2-0.3-0.2-0.9v-1.9q0-0.7-0.4-1-0.5-0.4-1.2-0.4-0.5 0-0.9 0.2-0.4 0.1-0.6 0.5-0.2 0.2-0.2 0.6h0.9q0-0.3 0.2-0.4 0.2-0.2 0.5-0.2 0.4 0 0.6 0.2 0.2 0.2 0.2 0.5v0.3h-0.6q-0.9 0-1.4 0.4-0.5 0.3-0.5 1 0 0.6 0.4 0.9 0.4 0.4 1 0.4 0.7 0 1.1-0.5 0.1 0.3 0.1 0.4h1zm-1.6-1.9h0.5v0.8q-0.2 0.2-0.4 0.3-0.2 0.2-0.5 0.2-0.3 0-0.5-0.2-0.2-0.1-0.2-0.4 0-0.3 0.3-0.5 0.2-0.2 0.8-0.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionaries);
export default __webpack_public_path__ + "static/media/dictionaries.45d44607a1c0f9701fb8560d5b04efb4.svg";
export { ForwardRef as ReactComponent };